// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__vE-qb","active":"tabs_active__lVPKZ","inactive":"tabs_inactive__T3ZvM","empty":"tabs_empty__Pqdhy"};